module.exports = __webpack_public_path__ + "static/img/complain.7684f24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/complain.png
// module id = ti6g
// module chunks = 7